export default __webpack_public_path__ + "static/media/andrew_pattison.39296ef2.jpg";